import * as Constants from "./availability-constants";
import * as ChannelModels from "../agent-channels/channels-models";
import { ChannelsConstants } from "../agent-channels/channels-constants";

/** Interface to access the availability service singleton */
export interface AvailabilityService {
  /** Expose agent sdk availability status */
  getAvailabilityStatus(): ChannelModels.CantileverAvailabiltyStates;

  /** Initialize service */
  /** @param supportedModalities list of modalities to initialize */
  /** @param callback callback method to get notified of any events */
  init(
    supportedModalities: Constants.Modality[],
    callback: OnAvailabilityEventCallback
  ): ng.IPromise<ChannelModels.PromiseResult>;

  /** Update presence status */
  /** @param state target presence state to change to */
  updatePresence(state: ModalityState): ng.IPromise<ChannelModels.PromiseResult>;

  /**
   * Update the presence state for another agent
   * @param agentId: the target agent Id
   * @param newState: the availability state object
   * @param curState: the target agent current State */
  updateAgentPresence(
    agentId: string,
    newState: ModalityState,
    curState: ModalityState
  ): ng.IPromise<ChannelModels.PromiseResult>;
}

export interface ModalityUpdate {
  /** Availability status for each supported modality */
  modalityDetails: ChannelModels.ModalityAvailability[];

  /** Agent OID */
  updatedBy: string;
}

export type OnAvailabilityEventCallback = (
  event: Constants.AvailabilityEvent,
  oldState: ChannelModels.ModalityAvailability,
  newState: ChannelModels.ModalityAvailability,
  message?: string,
  error?: string
) => void;

export class CantileverState {
  // @ngInject
  constructor(private _availabilityStatus: Constants.CantileverPresenceState, private _reason: any) {}

  get availabilityStatus(): Constants.CantileverPresenceState {
    return this._availabilityStatus;
  }

  get reason(): any {
    return this._reason;
  }
}

/** Container representing presence state for a given modality */
export interface ModalityState {
  modality: Constants.Modality;
  cantileverState: CantileverState;
}

export interface ModalityAvailabilityTuple {
  oldState: ChannelModels.ModalityAvailability;
  newState: ChannelModels.ModalityAvailability;
}
